<div *ngIf="showFloatTitle" class="floating-title caption-4">{{ 'DATA.SHARED.APPEALS.DATA_ABOUT_ITEM_OF_DATASET' | translate }}</div>

<div [ngStyle]="{ 'border-radius': borderRadius }" [class.impaired]="isImpaired" class="info">
  <button class="btn-empty close-btn" type="button" (click)="close.emit()"><svg [icon]="icons.Close" class="svg20 dark-gray-color" /></button>
  <div
    (resized)="resizeTitle($event)"
    [ngClass]="{ 'h3 obj-title': !isImpaired, 'h2-impaired impaired': isImpaired }"
  >
    {{headTitle}}
  </div>
  <div *ngIf="showImpairedTitle" class="impaired vl"></div>

  <div class="item" [class.impaired]="isImpaired" [style.height]="itemHeight">
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { columns: itemColumns, itemData: itemData, index: 1 }"> </ng-container>
    <button *ngIf="showEmptyValueButton && emptyValue.length > 0" (click)="showEmptyValueFields()" class="mt16 mb32 fields-button btn-secondary">
      {{ (emptyValue[0].show ? 'OTHER.HIDE_ALL_FIELDS' : 'OTHER.SHOW_ALL_FIELDS') | translate }}
      <svg class="svg24 ml8" [icon]="emptyValue[0].show ? icons.ExpandMoreUp : icons.ExpandMoreDown"></svg>
    </button>
  </div>
</div>

<ng-template
  #fieldTemplate
  let-itemData="itemData"
  let-columns="columns"
  let-isTable="isTable"
  let-index="index"
  let-tableClassValue="tableClassValue"
>
  <ng-container *ngFor="let attr of columns">
    <ng-container
      *ngIf="
        itemData &&
        (showAllFields || (itemData[attr.name] && (itemData[attr.name].show || itemData[attr.name].showTableData || attr.type === tableType)))
      "
    >
      <div class="column2" *ngIf="isTable && attr.type === tableType; else fieldContent">
        <ng-container *ngTemplateOutlet="fieldContent"></ng-container>
      </div>

      <ng-template #fieldContent>
        <div
          class="item-header"
          [ngClass]="{ 'header-underline table-header': attr.type === tableType && !isImpaired, 'header-impaired': isImpaired && attr.type === tableType }"
        >
          <div
            [ngClass]="{ cursor: attr.type === tableType }"
            [style.margin-left]="isImpaired && index ? index * 32 + 'px' : ''"
            class="caption-1"
            (click)="attr.type === tableType ? showTableData(itemData[attr.name]) : ''"
          >
            <span [innerHTML]="attr.title | safeHTML"></span>:
          </div>
          <ng-container *ngIf="attr.type === tableType">
            <button *ngIf="!isImpaired" class="btn-empty" (click)="showTableData(itemData[attr.name])">
              <svg [icon]="itemData[attr.name]?.showTableData ? icons.ArrowDropUp : icons.ArrowDropDown" class="svg18" />
            </button>

            <button *ngIf="isImpaired" class="btn-empty" (click)="showTableData(itemData[attr.name])">
              <app-impaired-icon [iconName]="itemData[attr.name]?.show ? icons.BigTriangleUp : icons.BigTriangleDown"></app-impaired-icon>
            </button>
          </ng-container>
        </div>

        <ng-container [ngSwitch]="attr.type">
          <ng-container *ngSwitchCase="fileType">
            <div class="mb16">
              <app-catalog-item-card-files-info
                [filesData]="fileDataList(itemData[attr.name].value)"
              ></app-catalog-item-card-files-info>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="dictionaryType">
            <ng-container *ngIf="!itemData[attr.name]?.length">
              <div *ngFor="let i of itemData[attr.name]; let last = last" class="body-1 mb16">
                {{ i + (!last ? ';' : '') }}
              </div>
            </ng-container>

            <div
              [ngClass]="{ 'caption-1': tableClassValue, 'body-1': !tableClassValue }"
              class="mb16"
              [ngStyle]="{ color: tableClassValue ? 'black' : '' }"
            >
              {{ itemData[attr.name]?.value ? '' : itemData[attr.name] }}
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="tableType">
            <div *ngIf="isImpaired && itemData[attr.name]?.show" class="vl"></div>
            <div
              *ngIf="itemData[attr.name]?.showTableData"
              [style.margin-left]="isImpaired ? '' : index * 16 + 'px'"
              [ngClass]="{ 'table-impaired': isImpaired }"
              class="value-table item-table"
            >
              <ng-container *ngFor="let data of itemData[attr.name]; let last = last">
                <ng-container
                  *ngTemplateOutlet="
                    fieldTemplate;
                    context: { itemData: data, columns: attr.catalogColumns, isTable: true, index: index + 1, tableClassValue: true }
                  "
                >
                </ng-container>
                <div *ngIf="itemData[attr.name]?.length > 1 && !isImpaired" class="horizontal-line column2"></div>
              </ng-container>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="linkType">
            <div class="mb16 " *ngIf="itemData[attr.name].constructor.name === 'Array' && itemData[attr.name].length">
              <span *ngFor="let elem of itemData[attr.name]; let last = last">
                <span class="link-2" (click)="openLinkCard(elem, attr)">{{ elem.value }}</span>
                <ng-container *ngIf="!last">, </ng-container>
              </span>
            </div>
            <div class="mb16 link-2" *ngIf="itemData[attr.name].value" (click)="openLinkCard(itemData[attr.name], attr)">
              {{ itemData[attr.name].value }}
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <div
              [ngClass]="{ 'caption-1': tableClassValue, 'body-1': !tableClassValue }"
              class="mb16"
              [ngStyle]="{ color: tableClassValue ? 'black' : '' }"
            >
              {{ itemData[attr.name]?.value ? '' : itemData[attr.name] }}
            </div>
          </ng-container>
        </ng-container>
        <div *ngIf="isImpaired" class="vl"></div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-template>
